import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import {getImpresionCotizacionPDF, getListOfQuotes} from "../../services/cotizador-service";
import {getImpresionEmisionPDFKerno, getListOfEmissions} from "../../services/emission-service";
import DataTable from 'react-data-table-component';
import Swal from "sweetalert2";
import ModalReceiptPolicy from "../../components/Modals/Modal-Receipt-Policy";
import ModalRequote from "../../components/Modals/Modal-Requote";
import moment from "moment";
import {handleLogout} from "../../services/auth-service";
import ModalXMLVisualizer from "../../components/Modals/Modal-XML-Visualizer";
import Tooltip from "react-bootstrap/Tooltip";
import {OverlayTrigger} from "react-bootstrap";

export let workOrderIdEmissions;
export let movementIdEmissions;

export default function Consult(props) {

    const [quotesTable, setQuotesTable] = useState([]); //Here we save the data table
    const [filterQuoteNumber, setFilterQuoteNumber] = useState(''); //Input value to search
    const [resetQuotesTable, setResetQuotesTable] = useState(false); //Flag to reset values
    const filteredQuotes = quotesTable?.filter(
        item => item?.quoteNumber && item?.quoteNumber?.toLowerCase().includes(filterQuoteNumber?.toLowerCase()),
    ); //Method to filter the quotes

    const [emissionsTable, setEmissionsTable] = useState([]); //Here we save the data table
    const [filterPolicyNumber, setFilterPolicyNumber] = useState(''); //Input value to search
    const [resetPolicyTable, setResetPolicyTable] = useState(false);
    const filteredPolicy = Object.values(emissionsTable)?.filter( //Method to filter the policies
        item => item?.policyNumber && item?.policyNumber?.toLowerCase().includes(filterPolicyNumber?.toLowerCase()),
    );

    const [pendingQuotes, setPendingQuotes] = useState(true); //Loading animation
    const [pendingEmissions, setPendingEmissions] = useState(true); //Loading animation

    const [showModalRequote, setShowModalRequote] = useState(false);
    const toggleModalRequote = () => { //Let us open and close modal
        setShowModalRequote(!showModalRequote);
    };

    const [showModalReceipts, setShowModalReceipts] = useState(false);
    const toggleModalReceipts = () => { //Let us open and close modal
        setShowModalReceipts(!showModalReceipts);
    };

    const [showModalXML, setShowModalXML] = useState(false);
    const toggleModalXML = () => { //Let us open and close modal
        setShowModalXML(!showModalXML);
    };

    const [movementId, setMovementId] = useState(null);
    const currentTime = moment().format('DD/MM/yyyy');

    //When component starts...
    useEffect(() => {
        //Request for getting quotes
        getListOfQuotes().then(data => {
            setQuotesTable(data);
            console.log(data)
            setPendingQuotes(false);
        }).catch(error => {
            setPendingQuotes(false);
            if (error.response.status == 401) {
                Swal.fire({
                    title: 'La sesión expiró',
                    text: 'Accede nuevamente',
                    icon: 'info',
                    iconColor: 'var(--skrSecondary)',
                    backdrop: `rgba(71, 10, 104, .75)`,
                    showCancelButton: true,
                    showConfirmButton: false,
                    cancelButtonColor: 'var(--skrSecondary)',
                    cancelButtonText: 'Ok'
                });
                return handleLogout();
            }
        });
        //Request for getting emissions
        getListOfEmissions().then(data => {
            setEmissionsTable(data);
            setPendingEmissions(false);
        }).catch(error => {
            setPendingEmissions(false);
        });
    }, []);

    const columnsQuotation = [
        {
            name: 'Compañía',
            compact: true,
            selector: row => row.insuranceCompany,
            sortable: false,
            center: true,
        },
        {
            name: 'ZIPCODE',
            compact: true,
            selector: row => row.zipCode,
            omit: true,
            center: true,
        },
        {
            name: 'quoteNumber',
            compact: true,
            selector: row => row.quoteNumber,
            omit: true,
            center: true,
        },
        {
            name: 'movementId',
            selector: row => row.movementId,
            omit: true,
            wrap: true,
            compact: true,
            center: true,
        },
        {
            name: 'insuranceCompanyId',
            compact: true,
            selector: row => row.insuranceCompanyId,
            omit: true,
            center: true,
        },
        {
            name: 'No. Cotización',
            compact: true,
            wrap: true,
            selector: row => row.quoteNumber,
            center: true,
        },
        {
            name: 'Valor Factura',
            compact: true,
            wrap: true,
            center: true,
            selector: row => {
                if (row.insuredAmount == 0) {
                    return 'Valor Comercial'
                } else if (row.insuredAmount === null) {
                    return 'Valor Comercial'
                } else {
                    return '$' + row.insuredAmount?.toLocaleString('en', {maximumFractionDigits: 2})
                }
            },
        },
        {
            name: 'Prima Total',
            compact: true,
            wrap: true,
            center: true,
            selector: row => <span>${row.totalPremium?.toLocaleString('en', {maximumFractionDigits: 2})}</span>,
        },
        {
            name: 'Vehículo',
            compact: true,
            wrap: true,
            width: '20rem',
            center: true,
            selector: row => row.vehicle,
        },
        {
            name: 'Modelo',
            compact: true,
            wrap: true,
            center: true,
            selector: row => row.modelYear
        },
        {
            name: 'Fecha de Inicio',
            compact: true,
            wrap: true,
            center: true,
            omit: true,
            selector: row => moment(row.startDate).format('DD/MM/yyyy'),
        },
        {
            name: 'Fecha de Término',
            compact: true,
            wrap: true,
            center: true,
            selector: row => moment(row.endDate).format('DD/MM/yyyy'),

        },
        {
            name: 'Estatus',
            compact: true,
            wrap: true,
            center: true,
            selector: row => row.catStatus,
            conditionalCellStyles: [
                {
                    when: row => row.catStatusId === 1, //Activo
                    style: {
                        color: '#470A68',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 2, //Inactivo
                    style: {
                        color: '#707070',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 3, //Emitido
                    style: {
                        color: '#28a745',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 4, //Emitido con error
                    style: {
                        color: '#dc4545',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 5, //Cancelado
                    style: {
                        color: '#dc4545',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 6, //Borrado
                    style: {
                        color: '#dc4545',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 7, //Error
                    style: {
                        color: '#dc4545',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 8, //Vencido
                    style: {
                        color: '#707070',
                        fontWeight: 600,
                    },
                },
            ],
        },
        {
            name: 'Forma de pago',
            compact: true,
            selector: row => row.wayToPayId,
            omit: true,
            center: true,
        },
        {
            name: 'Acciones',
            compact: true,
            wrap: true,
            center: true,
            width: '14rem',
            selector: row =>
                <div className="btn-group-sm" role="group" aria-label="Acciones">
                    {row.catStatusId === 8 ? (
                        <button disabled={true} type="button"
                                className="btn btn-skr-secondary text-light mx-1">Emitir</button>
                    ) : <Link to={`/emision=private/${row.insuranceCompanyId}/${row.movementId}/${row.zipCode}/${row.wayToPayId}`}>
                        <button type="button" className="btn btn-skr-secondary btn-sm text-light mx-1"
                                hidden={props.userPermissions[2] !== 1}>
                            Emitir
                        </button>
                    </Link>}
                    {row.catStatusId === 8 ? (
                        <OverlayTrigger placement="top" overlay={<Tooltip>Recotizar</Tooltip>}>
                            <button onClick={() => {
                                setMovementId(row.movementId);
                                toggleModalRequote()
                            }} className="btn btn-skr-secondary text-light mx-1" hidden={props.userPermissions[4] !== 1}><i
                                className="bi-arrow-repeat"></i></button>
                        </OverlayTrigger>
                    ) : <OverlayTrigger placement="top" overlay={<Tooltip>Recotizar</Tooltip>}>
                        <button className="btn btn-skr-secondary text-light mx-1" disabled={true}
                                hidden={props.userPermissions[4] !== 1}><i className="bi-arrow-repeat"></i></button>
                    </OverlayTrigger>}
                    <OverlayTrigger placement="top" overlay={<Tooltip>Ver XML</Tooltip>}>
                        <button type="button" className="btn btn-skr-secondary text-light mx-1"
                                onClick={() => {
                                    movementIdEmissions = 0;
                                    movementIdEmissions = row.movementId;
                                    toggleModalXML();
                                }}><i className="bi-file-earmark-code"></i></button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip>Descargar PDF</Tooltip>}>
                        <button type="button" className="btn btn-skr-secondary text-light mx-1"
                                hidden={props.userPermissions[1] !== 1}
                                onClick={() => {
                                    Swal.fire({
                                        title: 'Descargando PDF...',
                                        showConfirmButton: false,
                                        allowOutsideClick: false,
                                        didOpen: () => {
                                            Swal.showLoading()
                                            return getImpresionCotizacionPDF(row.movementId).then(data => {
                                                const url = window.URL.createObjectURL(new Blob([data]));
                                                const link = document.createElement('a');
                                                link.href = url;
                                                link.setAttribute('download', row.quoteNumber + '.pdf');
                                                document.body.appendChild(link);
                                                link.click();
                                            }).then(() => Swal.close()).catch(error => {
                                                Swal.fire({
                                                    title: 'Ocurrió un error',
                                                    text: `No se pudo descargar el PDF`,
                                                    icon: 'error',
                                                    iconColor: 'var(--skrSecondary)',
                                                    backdrop: `rgba(71, 10, 104, .75)`,
                                                    showCancelButton: true,
                                                    showConfirmButton: false,
                                                    cancelButtonColor: 'var(--skrSecondary)',
                                                    cancelButtonText: 'Ok'
                                                });
                                            })
                                        }
                                    })
                                }}><i className="bi-file-arrow-down"></i></button>
                    </OverlayTrigger>
                </div>,
        },
    ];

    const columnsPolicies = [
        {
            name: 'Compañía',
            selector: row => row.insuranceCompany,
            sortable: true,
            compact: true,
            wrap: true,
            center: true,
        },
        {
            name: 'Compañía ID',
            selector: row => row.insuranceCompanyId,
            omit: true,
            compact: true,
            wrap: true,
            center: true,
        },
        {
            name: 'Movement ID',
            selector: row => row.movementId,
            omit: true,
            center: true,
        },
        {
            name: 'Póliza',
            selector: row => row.policyNumber,
            compact: true,
            width: '8rem',
            wrap: true,
            center: true,
        },
        {
            name: 'Vehículo',
            selector: row => row.vehicle,
            compact: true,
            wrap: true,
            center: true,
            width: '18rem',
        },
        {
            name: 'Año Modelo',
            selector: row => row.modelYear,
            compact: true,
            wrap: true,
            center: true,
        },
        {
            name: 'Serie',
            selector: row => row.serialNumber,
            compact: true,
            width: '10rem',
            wrap: true,
            center: true,
        },
        {
            name: 'Motor',
            selector: row => row.engine,
            compact: true,
            wrap: true,
            omit: true,
            center: true,
        },
        {
            name: 'Placas',
            selector: row => row.plates,
            compact: true,
            wrap: true,
            center: true,
        },
        {
            name: 'No. Unidad',
            selector: row => row.unitNumber,
            compact: true,
            wrap: true,
            omit: true,
            center: true,
        },
        {
            name: 'Fecha de Inicio',
            selector: row => moment(row.startDate).format('DD/MM/yyyy'),
            compact: true,
            omit: true,
            wrap: true,
            center: true,
        },
        {
            name: 'Fecha de Término',
            selector: row => moment(row.endDate).format('DD/MM/yyyy'),
            compact: true,
            wrap: true,
            center: true,
        },
        {
            name: 'Cliente',
            selector: row => row.customer,
            compact: true,
            wrap: true,
            center: true,
        },
        {
            name: 'workOrderId',
            selector: row => row.workOrderId,
            omit: true,
            center: true,
        },
        {
            name: 'Estatus',
            selector: row => (<div className="status rounded p-1">{row.catStatus}</div>),
            compact: true,
            wrap: true,
            center: true,
            conditionalCellStyles: [
                {
                    when: row => row.catStatusId === 0, //Activo
                    style: {
                        color: '#470A68',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 1, //Activo
                    style: {
                        color: '#470A68',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 2, //Inactivo
                    style: {
                        color: '#707070',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 3, //Emitido
                    style: {
                        color: '#28a745',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 4, //Emitido con error
                    style: {
                        color: '#dc4545',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 5, //Cancelado
                    style: {
                        color: '#dc4545',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 6, //Borrado
                    style: {
                        color: '#dc4545',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 7, //Error
                    style: {
                        color: '#dc4545',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.catStatusId === 8, //Vencido
                    style: {
                        color: '#707070',
                        fontWeight: 600,
                    },
                },
            ],
        },
        {
            name: 'Acciones',
            compact: true,
            center: true,
            width: '12rem',
            selector: row =>
                <div className="btn-group-sm" role="group" aria-label="Acciones">
                    <button type="button" className="btn btn-skr-secondary btn-sm text-light mx-1"
                            onClick={() => {
                                workOrderIdEmissions = row.workOrderId;
                                toggleModalReceipts();
                            }}>Cobranza
                    </button>
                    <OverlayTrigger placement="top" overlay={<Tooltip>Ver XML</Tooltip>}>
                        <button type="button" className="btn btn-skr-secondary btn-sm text-light mx-1"
                                onClick={() => {
                                    movementIdEmissions = 0;
                                    workOrderIdEmissions = row.workOrderId;
                                    toggleModalXML();
                                }}><i className="bi-file-earmark-code"></i></button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip>Descargar PDF</Tooltip>}>
                        <button type="button" className="btn btn-skr-secondary btn-sm text-light mx-1"
                                hidden={props.userPermissions[1] !== 1}
                                onClick={() => {
                                    Swal.fire({
                                        title: 'Descargando PDF...',
                                        text: '(Esto puede tardar algunos segundos)',
                                        showConfirmButton: false,
                                        allowOutsideClick: false,
                                        didOpen: () => {
                                            Swal.showLoading();
                                            return getImpresionEmisionPDFKerno(row.workOrderId).then(data => {
                                                const url = window.URL.createObjectURL(new Blob([data]));
                                                const link = document.createElement('a');
                                                link.href = url;
                                                link.setAttribute('download', row.policyNumber + '.pdf');
                                                document.body.appendChild(link);
                                                link.click();
                                            }).then(() => Swal.close()).catch(() => {
                                                Swal.fire({
                                                    title: 'Ocurrió un error',
                                                    text: `No se pudo descargar el PDF`,
                                                    backdrop: `rgba(71, 10, 104, .75)`,
                                                    icon: 'error',
                                                    iconColor: 'var(--skrSecondary)',
                                                    showCancelButton: true,
                                                    showConfirmButton: false,
                                                    cancelButtonColor: 'var(--skrSecondary)',
                                                    cancelButtonText: 'Ok'
                                                });
                                            })
                                        }
                                    })
                                }}><i className="bi-file-arrow-down"></i>
                        </button>
                    </OverlayTrigger>
                </div>,
        },];

    return (
        <>
            {showModalXML ? <ModalXMLVisualizer isOpen={showModalXML} toggle={toggleModalXML}/> : null}
            {showModalReceipts ? <ModalReceiptPolicy isOpen={showModalReceipts} toggle={toggleModalReceipts}
                                                     userPermissions={props.userPermissions}/> : null}
            {showModalRequote ?
                <ModalRequote isOpen={showModalRequote} toggle={toggleModalRequote} movementId={movementId}/> : null}

            <div className="container my-5 mx-auto p-3 card-border col-11">
                {props.userPermissions[0] === 1 ? //Permisos de Cotizacion
                    <>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col">
                                    <h4 className="montserratMedium m-4">Cotizaciones</h4>
                                </div>
                                <div className="col-4">
                                    <div className="input-group mt-3">
                                        <input type="text" className="search border-end-0"
                                               placeholder="Buscar por número de cotización"
                                               onChange={e => setFilterQuoteNumber(e.target.value)}/>
                                        <div className="input-group-prepend">
                                            <span className="input-group-text bg-transparent border-start-0 m-0 p-1"><i
                                                className="bi bi-search"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid w-auto">
                            <div className="row">
                                <div className="col">
                                    <DataTable
                                        columns={columnsQuotation}
                                        data={filteredQuotes ?? quotesTable}
                                        pagination={true}
                                        paginationResetDefaultPage={resetQuotesTable}
                                        responsive={true}
                                        progressPending={pendingQuotes}/>
                                </div>
                            </div>
                        </div>
                    </> : null}

                {props.userPermissions[0] === 1 ? //Permisos de Emision
                    <>
                        <div className="container-fluid mt-4">
                            <div className="row">
                                <div className="col">
                                    <h4 className="montserratMedium m-4">Pólizas adquiridas</h4>
                                </div>
                                <div className="col-4">
                                    <div className="input-group mt-3">
                                        <input type="text" className="search border-end-0"
                                               placeholder="Buscar por número de póliza"
                                               onChange={e => setFilterPolicyNumber(e.target.value)}/>
                                        <div className="input-group-prepend">
                                                <span className="input-group-text bg-transparent border-start-0 m-0 p-1"><i
                                                    className="bi bi-search"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="container-fluid w-auto">
                                <div className="row">
                                    <div className="col">
                                        <DataTable
                                            columns={columnsPolicies}
                                            data={filteredPolicy ?? emissionsTable}
                                            pagination={true}
                                            paginationResetDefaultPage={resetPolicyTable}
                                            responsive={true}
                                            progressPending={pendingEmissions}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </> : null}

            </div>


        </>
    );
}